<template>
  <div v-if="$layout.isMobile" class="footer-layout mobile flex-column" :class="nologo ? 'nologo' : undefined">
    <div class="logo" v-if="!nologo">
      <slot name="logo"></slot>
    </div>
    <div class='nav flex-column'>
      <slot name="nav"></slot>
    </div>
    <div class='contacts flex-column'>
      <slot name="contacts"></slot>
    </div>
  </div>
  <div v-else-if="$layout.less1366" class="footer-layout flex-row space-between mid">
    <div class="flex-column logo cc1">
      <slot name="logo"></slot>
    </div>
    <div class="flex-row cc1">
      <div class='flex-column cc1'>
        <slot name="contacts"></slot>
      </div>
      <div class='flex-column cc1'>
        <slot name="nav"></slot>
      </div>
    </div>
  </div>
  <div v-else class="footer-layout flex-row space-between">
    <div class='col1 flex-column space-between'>
      <div class="flex-column cc1">
        <slot name="contacts"></slot>
      </div>
      <div class="logo">
        <slot name="logo"></slot>
      </div>
    </div>
    <div class='flex-column cc1'>
      <slot name="servers"></slot>
    </div>
    <div class='flex-column cc1'>
      <slot name="nav"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterLayout',
  props: {
    nologo: Boolean,
  },
}
</script>

<style lang="scss" scoped>

.footer-layout.mobile.nologo {
  .nav {
    margin-top: 0px;
  }
}

.footer-layout.mobile {
  padding: 30px $side-gap-small;
  .logo {
    & > * {
      width: 120px;
    }
  }
}

.footer-layout.mid {
  padding: 30px $side-gap-small;
  .logo {
    & > * {
      width: 120px;
    }
  }
}

.footer-layout {
  background-color: $bg-color-1;
  padding: 50px 170px;

  .col1 {
    gap: 20px;
  }

  .cc1 {
    height: 100%;
    align-items: flex-start;
    gap:20px;
  }

  .nav, .contacts {
    margin-top: 40px;
    gap: 20px;
    align-items: flex-start;
  }

  .logo {
    & > * {
      width: 250px;
    }
  }
}
</style>
